import { UploadFileOutlined } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';

import { Tag } from './Tag.tsx';

type TagType = 'cserv';

type HeadingWithTagProps = {
  readonly heading: string;
  readonly tag: TagType;
};

const tags: Record<TagType, () => ReactNode> = {
  cserv: () => (
    <Tag style="outline" size="small">
      <UploadFileOutlined sx={{ fontSize: '16px' }} />
      ContentServ
    </Tag>
  ),
};

export const HeadingWithTag: React.FC<HeadingWithTagProps> = ({ heading, tag }: HeadingWithTagProps) => (
  <Box display="flex" flexDirection="row" gap={2}>
    <Typography fontWeight="500">{heading}</Typography>
    {tags[tag]()}
  </Box>
);
